export const OPTIONS_EXTERIOR_CONDITIONS = [ "Excellent", "Good", "Average", "Fair" ]
export const OPTIONS_INTERIOR_CONDITIONS = [ "Excellent", "Good", "Average", "Fair" ]
export const OPTIONS_MECHANICAL_CONDITIONS = [ "Excellent", "Good", "Average", "Fair" ]
export const OPTIONS_DRIVABLE = [ "Yes", "No" ]